var AT_Slider ={
  
  	owlSlider : function(){
      
      	jQuery(".trending-now").length && jQuery('.trending-now').owlCarousel({
          	nav			: true
          	,dots 		: false
      		,items		: 6
			,responsive : {
                0:{
                	items: 1
                }
              	,480:{
                	items: 2
                }
            	,768:{
              		items: 3
            	}
              	,1024:{
              		items: 4
            	}
            	,1180:{
              		items: 6
            	}
          	}
          	,navText	: ['<i class="fa fa-angle-left" title="previous"></i>', '<i class="fa fa-angle-right" title="Next"></i>']
        });
      
      	jQuery(".big-single-product-slider").length && jQuery('.big-single-product-slider').owlCarousel({
          	nav			: false
          	,dots 		: false
          	,mouseDrag	: false
          	,margin		: 5
      		,items		: 1
        });
      
      	jQuery('.single-product-grid .horizontal-thumb').on("click", function(e){
            var $this = $(this);
            $this.addClass('active').parent().siblings().find('.active').removeClass('active');
        });
      
      	jQuery("#widget-partner").length && jQuery('#widget-partner').owlCarousel({
          	nav			: true
          	,dots 		: false
      		,items		: 6
			,responsive : {
                0:{
                	items: 1
                }
              	,480:{
                	items: 2
                }
            	,768:{
              		items: 3
            	}
              	,1024:{
              		items: 4
            	}
            	,1180:{
              		items: 6
            	}
          	}
          	,navText	: ['<i class="fa fa-angle-left" title="previous"></i>', '<i class="fa fa-angle-right" title="Next"></i>']
        });
      
      	jQuery(".related-items").length && jQuery('.related-items').owlCarousel({
          	nav			: true
          	,dots 		: false
      		,items		: 4
			,responsive : {
                0:{
                	items: 1
                }
            	,480:{
              		items: 2
            	}
            	,768:{
              		items: 3
            	}
            	,1180:{
              		items: 4
            	}
          	}
          	,navText	: ['<i class="fa fa-angle-left" title="previous"></i>', '<i class="fa fa-angle-right" title="Next"></i>']
        });

        var gallery = jQuery('#gallery-image');
        if (gallery.length && !gallery.data('iceGalleryResponsive')) {
          gallery.data('iceGalleryResponsive', true);
          var mobileGallery = window.matchMedia('(max-width: 767px)');
          var syncGallery = function() {
            if (mobileGallery.matches) {
              if (gallery.data('owl.carousel')) {
                gallery.trigger('destroy.owl.carousel');
              }
              gallery.removeClass('owl-carousel owl-loaded owl-hidden');
            } else if (!gallery.data('owl.carousel')) {
              gallery.owlCarousel({
                nav: false,
                dots: true,
                mouseDrag: true,
                margin: 0,
                responsive: { 0: { items: 3 }, 1199: { items: 6 } }
              });
            }
          };
          syncGallery();
          if (mobileGallery.addEventListener) {
            mobileGallery.addEventListener('change', syncGallery);
          } else {
            mobileGallery.addListener(syncGallery);
          }
        }
    	
	}
  
  	,init : function(){
      this.owlSlider();
    }
  
}

/* Check IE */
var bcMsieVersion = {

  MsieVersion: function() {

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))      // If Internet Explorer, return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)));
    else                 // If another browser, return 0
      {
      return 0;
    }
  }

  ,init : function(){
    this.MsieVersion();
  }
}

jQuery(document).ready(function($) {
	
	AT_Slider.init();
      
});